import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
type ComingSoonProps = {
  title: string;
  summary: string;
  notFound?: boolean;
};
export function ComingSoon({
  title,
  summary,
  notFound = false
}: ComingSoonProps) {
  return <section className="mx-auto max-w-3xl px-5 py-24 md:px-8 md:py-36" data-id="element-225" data-mp="3vgv5bmhi5821">
      <h1 className="font-serif text-5xl font-medium leading-tight text-forest md:text-6xl" data-id="element-226" data-mp="3vfk2ppzsm6ci">{title}</h1>
      <p className="mt-6 text-lg leading-relaxed text-ink-muted" data-id="element-227" data-mp="d95p5s5fryen">{summary}</p>

      {!notFound && <div className="mt-10 border-l-2 border-clay pl-5" data-id="element-228" data-mp="97kfefo7808o">
          <p className="font-medium text-ink" data-id="element-229" data-mp="n00cz0ybz627">Page en préparation</p>
          <p className="mt-1 text-ink-muted" data-id="element-230" data-mp="i28nsep2ly1p">
            Cette page sera produite après validation de la page d’accueil.
          </p>
        </div>}

      <div className="mt-12 flex flex-wrap gap-3" data-id="element-231" data-mp="wzher7agozsw">
        <Link to="/" className="inline-flex items-center gap-2 rounded-full border border-forest px-5 py-3 text-sm font-medium text-forest transition-colors duration-150 hover:bg-forest hover:text-cream" data-id="element-232" data-mp="s0obs8sswr6z">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-233" data-mp="125mnzo08t4dw" />
          Retour à l’accueil
        </Link>
        <Link to="/#devis" className="inline-flex items-center rounded-full bg-forest px-5 py-3 text-sm font-medium text-cream transition-colors duration-150 hover:bg-forest-dark" data-id="element-234" data-mp="165d9pdawwubk">
          Demander un devis
        </Link>
      </div>
    </section>;
}